import { SerologyListType } from '@nkr/store/serology-tracking';

export const listMap = [
    { id: SerologyListType.RequestsOfDonor},
    { id: SerologyListType.RequestsOfRecipient},
    { id: SerologyListType.ToDo},
    { id: SerologyListType.Closed }
];
